import { createStore, applyMiddleware } from 'redux';
import { createEpicMiddleware } from 'redux-observable';
import thunk from 'redux-thunk';
import { composeWithDevTools } from 'redux-devtools-extension';
import Reducer from './data/ducks';
import Epics from './data/epics/';

const epicMiddleware = createEpicMiddleware();

export default function configureStore() {
  const store = createStore(
    Reducer,
    composeWithDevTools({
      name: 'finauta-redux',
    })(
      applyMiddleware(epicMiddleware, thunk),
    ),
  );

  epicMiddleware.run(Epics);

  return {
    store,
  };
}
